import Image from 'next/image';
import { RemixiconReactIconComponentType } from 'remixicon-react';
import BarChart2FillIcon from 'remixicon-react/BarChart2FillIcon';
import GuideFillIcon from 'remixicon-react/GuideFillIcon';
import image from './advantage.png';
import UserHeartLineIcon from 'remixicon-react/UserHeartLineIcon';
import UmbrellaFillIcon from 'remixicon-react/UmbrellaFillIcon';
import FileWarningFillIcon from 'remixicon-react/FileWarningFillIcon';
import ShieldStarLineIcon from 'remixicon-react/ShieldStarLineIcon';
import { Button } from '@prishapolicy/shared/ui';
const AdvantagePoint = (props: { icon: RemixiconReactIconComponentType; text: string }) => {
  return (
    <div className="my-2.5 flex">
      <props.icon />
      <div className="ml-4">{props.text}</div>
    </div>
  );
};

export const PrishaPolicyAdvantage = () => {
  return (
    <div className="-mt-15 pt-24" id="the-prishapolicy-advantage">
      <div className="not-prose bg-blue-900 text-white lg:grid-cols-2 xl:grid xl:grid-cols-3">
        <div className="p-10 xl:col-span-2">
          <h2 className="text-title-6 mb-5 font-bold">The PrishaPolicy Advantage</h2>
          <div className="grid-cols-2 gap-4 xl:grid">
            <div>
              <AdvantagePoint icon={GuideFillIcon} text="Guided Policy Assistance" />
              <AdvantagePoint icon={BarChart2FillIcon} text="Decade of Market Leadership" />
              <AdvantagePoint icon={UserHeartLineIcon} text="Customer-Centric Culture" />
            </div>
            <div>
              <AdvantagePoint icon={UmbrellaFillIcon} text="Customised Insurance Policy" />
              <AdvantagePoint icon={FileWarningFillIcon} text="Dedicated Claims Assitance" />
              <AdvantagePoint icon={ShieldStarLineIcon} text="Reliable and Consistent" />
            </div>
          </div>
          <div className="mt-2.5 justify-start xl:flex">
            <Button
              openInNewTab
              theme="secondary"
              text="Download Company Intro"
              href="https://assets.prishapolicy.net/public-files/company-introduction.pdf"
            />
          </div>
        </div>
        <div className="flex items-end">
          <Image src={image} alt="prishapolicy advantage" className="mt-8" />
        </div>
      </div>
    </div>
  );
};
